import BaseMystery from '../BaseMystery'

const SecondLuminousMystery = () => {
	const imagesList = [
		"https://www.wga.hu/art/m/manetti/wed_cana.jpg",
		"https://www.wga.hu/art/g/giusto/padua/3north2.jpg",
		"https://www.wga.hu/art/d/duccio/maesta/predel_v/pre_v_5.jpg",
		"https://www.wga.hu/art/c/cossiers/cana_wed.jpg",
		"https://www.wga.hu/art/b/bosch/1early/10cana.jpg",
		"https://www.wga.hu/art/c/calvaert/marrcana.jpg",
		"https://www.wga.hu/art/d/david/2/cana_mar.jpg",
		"https://www.wga.hu/art/f/francken/frans2/marriage.jpg",
		"https://www.wga.hu/art/g/giotto/padova/3christ/chris08.jpg",
		"https://www.wga.hu/art/j/juan/2/polypty8.jpg",
		"https://www.wga.hu/art/p/pacher/wolfgang/3wolfgag.jpg",
		"https://www.wga.hu/art/p/preti/wedding.jpg",
		"https://www.wga.hu/art/s/schnorr/feast.jpg",
		"https://www.wga.hu/art/t/tintoret/3_1560s/2cana.jpg",
		"https://www.wga.hu/art/v/vasari/1/14cana.jpg",
		"https://www.wga.hu/art/v/vermeyen/marriage.jpg",
		"https://www.wga.hu/art/v/veronese/06/7dresde.jpg",
		"https://www.wga.hu/art/v/veronese/06/2cana.jpg",
		"https://www.wga.hu/art/v/vos_m/marriage.jpg",
	];

	const scriptureQuote = "\"Everyone serves good wine first, and then when people have drunk freely, an inferior one; but you have kept the good wine until now.\"";
	const scriptureCitation = "John 2:10 (NABRE)";
	const citationLink = "https://www.biblegateway.com/passage/?search=John%202%3A1-11&version=NABRE";

	return (
		<BaseMystery titleText="The Wedding Feast of Cana"
				imagesList={imagesList}
				scriptureQuote={scriptureQuote}
				scriptureCitation={scriptureCitation}
				citationLink={citationLink}
				rightHanded={true} />
	);
};

export default SecondLuminousMystery;